import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';

interface SectionHeaderProps {
  title: ReactNode;
  action?: ReactNode;
  className?: string;
}

/**
 * 랜딩 섹션 공용 헤더.
 * 타이틀 타이포그래피(text-xl font-black font-gmarket)와 하단 간격(mb-5)을 통일한다.
 * `action` 슬롯에는 `SectionMoreLink` 같은 우측 액션을 넣는다.
 */
export function SectionHeader({ title, action, className = '' }: SectionHeaderProps) {
  return (
    <div className={`flex items-center justify-between mb-5 ${className}`.trim()}>
      <h2 className="text-xl font-black font-gmarket text-nearblack flex items-center gap-2 text-balance">
        {title}
      </h2>
      {action ?? null}
    </div>
  );
}

interface SectionMoreLinkProps {
  to: string;
  label?: string;
}

/** 섹션 헤더 우측 "더보기" 링크 표준 스타일. */
export function SectionMoreLink({ to, label = '더보기' }: SectionMoreLinkProps) {
  return (
    <Link
      to={to}
      className="flex items-center text-sm font-bold text-gray-700 transition-colors hover:text-black"
    >
      {label} <ChevronRight size={14} />
    </Link>
  );
}
